<template>
  <span class="dlr-avatar" :class="`dlr-avatar--${size}`" :style="paletteStyle" :title="name || ''">
    <span class="dlr-avatar__initials">{{ initials }}</span>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{ name?: string | null; size?: 'sm' | 'md' | 'lg' }>(),
  { name: '', size: 'md' },
)

const PALETTE: { bg: string; fg: string }[] = [
  { bg: '#fee2e2', fg: '#991b1b' },
  { bg: '#ffedd5', fg: '#9a3412' },
  { bg: '#fef3c7', fg: '#92400e' },
  { bg: '#dcfce7', fg: '#166534' },
  { bg: '#cffafe', fg: '#155e75' },
  { bg: '#dbeafe', fg: '#1e40af' },
  { bg: '#ede9fe', fg: '#5b21b6' },
  { bg: '#fce7f3', fg: '#9d174d' },
]

function hashCode(s: string): number {
  let h = 0
  for (let i = 0; i < s.length; i += 1) {
    h = (h << 5) - h + s.charCodeAt(i)
    h |= 0
  }
  return Math.abs(h)
}

const initials = computed(() => {
  const n = String(props.name || '').trim()
  if (!n) return '·'
  const parts = n.split(/\s+/)
  const a = (parts[0] || '').charAt(0)
  const b = (parts[1] || (parts[0] || '').charAt(1) || '').charAt(0)
  return (a + b).toUpperCase()
})

const paletteStyle = computed(() => {
  const seed = String(props.name || 'x')
  const idx = hashCode(seed) % PALETTE.length
  const c = PALETTE[idx]
  return { background: c.bg, color: c.fg }
})
</script>

<style scoped>
.dlr-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-weight: 600;
  font-feature-settings: "tnum";
  flex: none;
  user-select: none;
}
.dlr-avatar--sm {
  width: 24px;
  height: 24px;
  font-size: 10px;
}
.dlr-avatar--md {
  width: 36px;
  height: 36px;
  font-size: 13px;
}
.dlr-avatar--lg {
  width: 48px;
  height: 48px;
  font-size: 16px;
}
.dlr-avatar__initials {
  letter-spacing: 0.02em;
}
</style>
